// Bilingual content (IT / EN) for Common Ground Project ETS.
// Non-localized assets (images, logo, PDF) live in ./site.js
import { IMG } from "./site";

const NAV_PATHS = {
  home: "/",
  about: "/chi-siamo",
  projects: "/progetti",
  gallery: "/immagini",
  contact: "/contatti",
  members: "/accedi",
};

export const CONTENT = {
  it: {
    nav: [
      { to: NAV_PATHS.home, label: "Home" },
      { to: NAV_PATHS.about, label: "Chi siamo" },
      { to: NAV_PATHS.projects, label: "Progetti" },
      { to: NAV_PATHS.gallery, label: "Immagini dal campo" },
      { to: NAV_PATHS.contact, label: "Contatti" },
      { to: NAV_PATHS.members, label: "Area soci" },
    ],
    donate: "Sostienici",
    home: {
      heroLead:
        "Common Ground Project è un'organizzazione privata che opera senza scopo di lucro per perseguire finalità civiche, solidarietà internazionale, la cooperazione tra i popoli e la valorizzazione della diversità culturale, in Italia e nel mondo.",
      heroMotto: "Avviciniamo ciò che è lontano, rendiamo visibile l'invisibile.",
      heroDonate: "Sostieni i progetti",
      heroProjects: "I nostri progetti",
      manifestoKicker: "LA NOSTRA MISSIONE",
      manifestoTitle: "Tre principi che guidano ogni intervento",
      manifesto: [
        { n: "01", title: "Un terreno comune", body: "Common Ground Project promuove la conoscenza e la valorizzazione delle culture, delle tradizioni e delle lingue dei popoli, favorendo il dialogo interculturale e l'integrazione. Crediamo che il confronto sia il primo strumento di cooperazione." },
        { n: "02", title: "Cooperazione e dignità", body: "Realizziamo interventi di cooperazione allo sviluppo a sostegno della nutrizione, della crescita, dell'istruzione e dello sviluppo dei minori e delle persone in condizione di svantaggio, in Italia e nel mondo." },
        { n: "03", title: "Diritti e uguaglianza", body: "Operiamo per la promozione dei diritti umani fondamentali, della giustizia e dell'uguaglianza di genere e per il contrasto di ogni forma di discriminazione, di povertà e di disuguaglianza economica e sociale." },
      ],
      activitiesKicker: "COSA FACCIAMO",
      activitiesTitle: "Ambiti di intervento",
      activities: [
        { title: "Promozione culturale", desc: "Festival, mostre, conferenze, corsi di lingua e laboratori dedicati alle culture del mondo." },
        { title: "Cooperazione allo sviluppo", desc: "Progetti per l'istruzione, la salute e le condizioni di vita di minori e persone svantaggiate." },
        { title: "Aiuto umanitario", desc: "Interventi di emergenza e assistenza a popolazioni colpite da crisi, conflitti o calamità." },
        { title: "Diritti e uguaglianza", desc: "Promozione dei diritti umani, della giustizia e dell'uguaglianza di genere." },
        { title: "Adozioni a distanza", desc: "Programmi di sostegno educativo e psico-affettivo per i minori." },
        { title: "Turismo responsabile", desc: "Viaggi di conoscenza, scambi culturali e turismo consapevole." },
      ],
      projectsKicker: "PROGETTI IN EVIDENZA",
      projectsTitle: "Interventi concreti, impatto misurabile",
      projectsAll: "Tutti i progetti",
      ctaKicker: "SOSTIENICI",
      ctaTitle: "Ogni contributo diventa istruzione, cultura e dignità.",
      ctaBody: "Le donazioni sostengono direttamente i progetti dell'organizzazione. Puoi contribuire in modo sicuro tramite pagamento online.",
      ctaBtn: "Fai una donazione",
    },
    about: {
      heroKicker: "CHI SIAMO",
      heroTitleLines: ["Un'organizzazione", "per il bene comune"],
      heroIntro: "Common Ground Project è un'organizzazione privata che opera senza scopo di lucro per perseguire finalità civiche, solidarietà internazionale, la cooperazione tra i popoli e la valorizzazione della diversità culturale, in Italia e nel mondo.",
      missionKicker: "MISSIONE",
      missionTitle: "Cultura e cooperazione, senza confini geografici",
      missionP1: "L'organizzazione opera senza limitazioni di area geografica, in Italia e in qualsiasi Paese del mondo. Promuove la conoscenza delle culture, realizza interventi di cooperazione allo sviluppo e fornisce aiuto umanitario a favore dei minori e delle persone in condizione di svantaggio.",
      missionP2: "Ogni risorsa raccolta è destinata alla realizzazione delle finalità statutarie.",
      valuesKicker: "I NOSTRI VALORI",
      valuesTitle: "Principi che orientano l'agire",
      values: ["Assenza di scopo di lucro", "Solidarietà umana e internazionale", "Cooperazione tra i popoli", "Valorizzazione della diversità culturale", "Promozione dei diritti umani", "Uguaglianza e giustizia di genere", "Contrasto a povertà e disuguaglianze", "Volontariato libero e gratuito"],
    },
    projects: {
      heroKicker: "PROGETTI",
      heroTitleLines: ["Dove operiamo,", "cosa realizziamo"],
      heroIntro: "Ogni progetto è documentato con obiettivi chiari e risultati verificabili. Trasparenza e impatto misurabile sono al centro del nostro modo di lavorare.",
      where: {
        kicker: "DOVE OPERIAMO",
        title: "Oggi Italia e Senegal, domani il mondo",
        intro: "L'organizzazione opera senza limitazioni geografiche. Oggi i progetti sono attivi in Italia e in Senegal; in futuro l'impegno si estenderà a nuovi Paesi e comunità in tutto il mondo.",
        places: {
          italy: { name: "Italia", desc: "Attività culturali, di sensibilizzazione e di raccolta fondi a sostegno dei progetti." },
          senegal: { name: "Senegal", desc: "Sostegno agli studenti e costruzione del centro di comunità." },
        },
      },
      galleryLabel: "GALLERIA FOTOGRAFICA",
      goalsLabel: "Obiettivi",
      contribute: "Contribuisci al progetto",
      items: [
        { id: "scuola-senegal", kicker: "Cooperazione allo sviluppo", title: "Sostegno agli studenti del Senegal", location: "Senegal", status: "In corso", lead: "Un programma di sostegno all'istruzione primaria rivolto ai bambini di una comunità rurale, con l'obiettivo di garantire continuità scolastica, materiali didattici e un pasto quotidiano.", goals: ["Copertura delle rette e del materiale scolastico per la frequenza dell'intero anno.", "Fornitura di materiale didattico e supporto alle attività educative.", "Sostegno alla nutrizione dei minori attraverso un pasto quotidiano.", "Monitoraggio periodico della frequenza e dei risultati scolastici."], cover: IMG.senegal, gallery: [] },
        { id: "centro-aggregazione", kicker: "Cultura e comunità", title: "Raccolta fondi per lo sviluppo di un centro di comunità", location: "Progetto in sviluppo", status: "In sviluppo", lead: "Il nuovo centro nasce come polo di aggregazione e cultura: un punto di riferimento per la comunità locale e un luogo di crescita educativa. È concepito come uno spazio flessibile e in evoluzione, destinato a diventare un cuore pulsante per la cultura e l'incontro, dove le attività verranno costruite insieme ai futuri frequentatori.", goals: ["Realizzazione di uno spazio polifunzionale per attività culturali, educative e sociali.", "Creazione di un punto di riferimento stabile e aperto per la comunità locale.", "Programmazione partecipata: attività definite insieme a chi frequenterà il centro.", "Sostenibilità e crescita progressiva degli spazi nel tempo."], cta: true, cover: IMG.centro, gallery: [] },
      ],
    },
    gallery: {
      heroKicker: "GALLERIA",
      heroTitleLines: ["Immagini", "dal campo"],
      closeLabel: "Chiudi",
      altLabel: "Immagine",
    },
    transparency: {
      heroKicker: "TRASPARENZA",
      heroTitleLines: ["Documenti", "e rendicontazione"],
      heroIntro: "La trasparenza è un impegno fondamentale. In questa sezione rendiamo disponibili gli atti dell'organizzazione e le informazioni utili a chi vuole conoscere e verificare il nostro operato.",
      docsTitle: "Documenti ufficiali",
      viewLabel: "Consulta",
      downloadLabel: "Scarica",
      documents: [
        { file: "statuto", title: "Statuto", desc: "Documento istitutivo dell'organizzazione: finalità, attività, struttura degli organi sociali e regole di funzionamento.", meta: "PDF" },
        { file: "adesione", title: "Modulo di adesione", desc: "Modulo per richiedere l'adesione all'organizzazione come socio: compilalo, firmalo e invialo all'indirizzo email indicato nei contatti.", meta: "PDF" },
      ],
      pillars: [
        { title: "Documenti consultabili", body: "Gli atti fondamentali dell'organizzazione sono liberamente accessibili e scaricabili." },
        { title: "Natura non lucrativa", body: "L'organizzazione non persegue alcuno scopo di lucro, nemmeno indiretto." },
        { title: "Rendicontazione", body: "Il bilancio e i rendiconti delle attività verranno pubblicati in questa sezione." },
      ],
    },
    donatePage: {
      heroKicker: "SOSTIENICI",
      heroTitleLines: ["Il tuo contributo", "fa la differenza"],
      heroIntro: "Sostieni concretamente i progetti di Common Ground Project. Scegli un importo o inserisci una cifra personalizzata: verrai indirizzato a una pagina di pagamento sicura.",
      chooseTitle: "Scegli il tuo contributo",
      chooseSub: "Donazione una tantum in Euro.",
      renewalTitle: "Rinnovo quota associativa.",
      renewalBody: "Scegli l'importo della quota e completa il pagamento: la tua tessera verrà rinnovata dall'organizzazione.",
      tiers: [
        { note: "Materiale didattico" },
        { note: "Un mese di sostegno" },
        { note: "Pasti e nutrizione" },
        { note: "Un contributo importante" },
      ],
      customLabel: "IMPORTO PERSONALIZZATO",
      customPlaceholder: "Altro importo",
      submitIdle: "Procedi alla donazione",
      submitLoading: "Reindirizzamento...",
      redirectNote: "Verrai reindirizzato alla pagina di pagamento sicura Stripe.",
      impact: [
        { title: "Destinazione diretta", body: "Le donazioni sono destinate integralmente alla realizzazione delle finalità statutarie." },
        { title: "Pagamento sicuro", body: "Le transazioni sono gestite in modo sicuro tramite Stripe. Non conserviamo i dati della tua carta." },
      ],
      quote: "\"Ogni contributo diventa istruzione, cultura e dignità.\"",
      errAmount: "Inserisci un importo valido (minimo 2€).",
      errGeneric: "Si è verificato un errore. Riprova più tardi.",
      errStart: "Impossibile avviare il pagamento. Riprova.",
    },
    contact: {
      heroKicker: "CONTATTI",
      heroTitleLines: ["Scrivici,", "collaboriamo"],
      heroIntro: "Per informazioni sui progetti, per diventare socio o per proporre una collaborazione, puoi contattare l'organizzazione ai recapiti indicati.",
      emailLabel: "Email",
      phoneLabel: "Telefono",
    },
    login: {
      heroKicker: "AREA SOCI",
      heroTitleLines: ["Accedi alla", "tua area"],
      quote: "\"Insieme costruiamo un terreno comune.\"",
      heroIntro: "Riservata ai soci di Common Ground Project. Inserisci la tua email: se sei tra i soci autorizzati potrai accedere con la tua password o crearne una al primo accesso.",
      cardTitle: "Accedi all'area soci",
      cardBody: "L'accesso è riservato agli indirizzi email dei soci registrati. Al primo accesso ti chiederemo di scegliere una password personale.",
      protectedTitle: "Accesso protetto",
      protectedBody: "Le password sono salvate in forma cifrata e la sessione resta attiva su questo dispositivo. In caso di smarrimento, l'organizzazione può reimpostare la tua password.",
      unauthorized: "Questo indirizzo non risulta tra i soci autorizzati. Se sei socio, scrivi a",
      emailLabel: "La tua email da socio",
      emailPlaceholder: "nome@esempio.it",
      continueBtn: "Continua",
      passwordLabel: "Password",
      loginBtn: "Accedi",
      forgot: "Password dimenticata?",
      back: "Cambia email",
      hello: "Ciao",
      createIntro: "indirizzo confermato: scegli la tua password.",
      verifying: "Verifica del link in corso...",
      verifyIntro: "è il tuo primo accesso.",
      verifyBody: "Per sicurezza ti invieremo un link di conferma all'indirizzo",
      sendLinkBtn: "Inviami il link di conferma",
      sentTitle: "Email inviata!",
      sentBody: "Abbiamo inviato un link di conferma a",
      sentHint: "Aprilo entro un'ora per creare la tua password. Controlla anche la cartella spam.",
      newPasswordLabel: "Nuova password",
      confirmPasswordLabel: "Conferma password",
      pwHint: "Almeno 8 caratteri",
      createBtn: "Crea password e accedi",
      pwTooShort: "La password deve contenere almeno 8 caratteri.",
      pwMismatch: "Le due password non coincidono.",
      genericError: "Qualcosa è andato storto. Riprova.",
    },
    member: {
      kicker: "AREA RISERVATA SOCI",
      greeting: "Ciao,",
      fallbackName: "socia/o",
      cards: [
        { title: "Il tuo profilo", body: "Qui trovi i tuoi dati di socia/o. Presto potrai aggiornare le tue preferenze e consultare lo storico delle attività." },
        { title: "Documenti riservati", body: "Verbali, comunicazioni ai soci e materiali interni saranno disponibili in questa sezione riservata." },
        { title: "Partecipa", body: "Grazie per far parte di Common Ground Project. Il tuo contributo rende possibili i nostri progetti di cooperazione." },
      ],
      logout: "Esci",
      cardKicker: "TESSERA ASSOCIATIVA 2026",
      cardNumber: "N. TESSERA",
      cardJoined: "ISCRIZIONE",
      cardExpires: "SCADENZA",
      cardFooter: "Tessera digitale valida come attestato di adesione a Common Ground Project ETS.",
      renewExpiredTitle: "La tua tessera è scaduta",
      renewExpiredBody: "La tessera associativa è scaduta il {date}. Rinnova la quota per continuare a far parte di Common Ground Project.",
      renewSoonTitle: "La tua tessera sta per scadere",
      renewSoonBody: "Mancano {days} giorni alla scadenza ({date}). Rinnova ora la quota associativa per non perdere i benefici da socio.",
      renewBtn: "Rinnova la quota",
      statusExpired: "Scaduta",
      statusExpiring: "Scade tra {days} giorni",
      statusValid: "Valida",
      driveTitle: "Documenti riservati",
      driveBody: "Verbali, comunicazioni ai soci e materiali interni sono raccolti nella cartella condivisa.",
      driveButton: "Apri la cartella documenti",
      driveRestricted: "L'accesso ai documenti riservati (verbali, comunicazioni interne) è limitato ai soci autorizzati dal direttivo. Se ritieni di doverne avere accesso, contatta l'organizzazione.",
      adminDocsBadge: "Documenti",
      adminDocsGrant: "Documenti: consenti",
      adminDocsRevoke: "Documenti: revoca",
      adminTitle: "Gestione accessi",
      adminSub: "Gestisci i soci che possono accedere all'area riservata. Puoi aggiungere o rimuovere indirizzi e reimpostare la password di un socio.",
      adminPlaceholder: "email@esempio.com",
      adminAdd: "Autorizza",
      adminRemove: "Rimuovi",
      adminListLabel: "Email autorizzate",
      adminNone: "Nessun socio registrato.",
      adminNamePlaceholder: "Nome e cognome",
      adminCountLabel: "soci",
      adminPwSet: "Password impostata",
      adminPwMissing: "In attesa di password",
      adminReset: "Reimposta password",
      adminResetDone: "Password reimpostata: il socio potrà crearne una nuova al prossimo accesso.",
      adminBadge: "Admin",
    },
    payment: {
      checking: "Verifica del pagamento...",
      checkingBody: "Attendi qualche istante, stiamo confermando la tua donazione.",
      paidTitle: "Grazie di cuore!",
      paidBody: (a) => `La tua donazione${a ? ` di ${a}€` : ""} è stata ricevuta con successo. Il tuo sostegno rende possibili i nostri progetti.`,
      home: "Torna alla home",
      pendingTitle: "Pagamento in elaborazione",
      pendingBody: "Riceverai conferma a breve. Puoi verificare più tardi.",
      errorTitle: "Qualcosa è andato storto",
      errorBody: "Non siamo riusciti a confermare il pagamento. Riprova o contattaci.",
      retry: "Riprova",
      cancelTitle: "Donazione annullata",
      cancelBody: "Il pagamento non è stato completato. Puoi riprovare quando vuoi: ogni contributo conta.",
    },
    cookie: {
      title: "Privacy e cookie",
      text: "Questo sito utilizza cookie tecnici necessari al funzionamento (lingua, sessione dell'Area soci) e, solo durante una donazione, cookie di terze parti del gestore dei pagamenti. Non utilizziamo cookie di profilazione.",
      accept: "Accetta",
      necessary: "Solo necessari",
      more: "Leggi l'informativa",
    },
    privacy: {
      heroKicker: "INFORMATIVA",
      heroTitleLines: ["Privacy", "e cookie"],
      heroIntro: "Informativa resa ai sensi del Regolamento (UE) 2016/679 (GDPR) sul trattamento dei dati personali degli utenti di questo sito.",
      sections: [
        { title: "Titolare del trattamento", body: "Il titolare del trattamento è Common Ground Project ETS. Per qualsiasi richiesta relativa ai dati personali è possibile scrivere a {email}." },
        { title: "Dati trattati e finalità", body: "Durante la navigazione vengono raccolti dati tecnici (indirizzo IP, tipo di browser, pagine visitate) necessari al funzionamento del sito e alla sua sicurezza. Se accedi all'Area soci, trattiamo il tuo nome, la tua email e la password (salvata esclusivamente in forma cifrata) per consentire l'autenticazione. Se effettui una donazione, i dati di pagamento sono trattati direttamente dal gestore dei pagamenti (Stripe) e non vengono memorizzati dall'organizzazione." },
        { title: "Base giuridica", body: "Il trattamento si fonda sull'esecuzione del servizio richiesto dall'utente (navigazione, accesso, donazione), sul legittimo interesse alla sicurezza del sito e, ove richiesto, sul consenso." },
        { title: "Cookie utilizzati", body: "Cookie tecnici: preferenza lingua e scelta cookie (memorizzate nel browser), sessione di accesso dell'Area soci. Cookie di terze parti: solo durante il pagamento, Stripe può impostare cookie necessari alla prevenzione delle frodi. Non utilizziamo cookie di profilazione o pubblicitari." },
        { title: "Conservazione", body: "I dati di navigazione sono conservati per il tempo strettamente necessario. La sessione dell'Area soci scade automaticamente dopo 7 giorni. I dati del profilo socio sono conservati finché l'utente rimane socio o fino a richiesta di cancellazione." },
        { title: "Diritti dell'interessato", body: "Hai diritto di accedere ai tuoi dati, chiederne la rettifica o la cancellazione, limitarne il trattamento, opporti e richiederne la portabilità, nonché proporre reclamo al Garante per la protezione dei dati personali. Puoi esercitare i tuoi diritti scrivendo a {email}." },
        { title: "Gestione del consenso", body: "Puoi modificare in qualsiasi momento la tua scelta sui cookie utilizzando il pulsante qui sotto." },
      ],
      resetBtn: "Modifica preferenze cookie",
      updated: "Ultimo aggiornamento: luglio 2026",
    },
    footer: {
      tagline: "Un terreno comune per la cooperazione, la cultura e la dignità delle persone.",
      privacyLink: "Privacy e cookie",
      navTitle: "NAVIGAZIONE",
      contactTitle: "CONTATTI",
      ets: "Ente del Terzo Settore",
    },
  },

  en: {
    nav: [
      { to: NAV_PATHS.home, label: "Home" },
      { to: NAV_PATHS.about, label: "About us" },
      { to: NAV_PATHS.projects, label: "Projects" },
      { to: NAV_PATHS.gallery, label: "Images from the field" },
      { to: NAV_PATHS.contact, label: "Contact" },
      { to: NAV_PATHS.members, label: "Members" },
    ],
    donate: "Donate",
    home: {
      heroLead:
        "Common Ground Project is a private non-profit organisation pursuing civic purposes, international solidarity, cooperation among peoples and the valorisation of cultural diversity, in Italy and around the world.",
      heroMotto: "We bring closer what is far away, we make the invisible visible.",
      heroDonate: "Support the projects",
      heroProjects: "Our projects",
      manifestoKicker: "OUR MISSION",
      manifestoTitle: "Three principles guiding every action",
      manifesto: [
        { n: "01", title: "A common ground", body: "Common Ground Project promotes the knowledge and appreciation of the cultures, traditions and languages of all peoples, fostering intercultural dialogue and integration. We believe dialogue is the first tool of cooperation." },
        { n: "02", title: "Cooperation and dignity", body: "We carry out development cooperation projects supporting the nutrition, growth, education and development of children and people in disadvantaged conditions, in Italy and worldwide." },
        { n: "03", title: "Rights and equality", body: "We work to promote fundamental human rights, justice and gender equality, and to fight every form of discrimination, poverty and economic and social inequality." },
      ],
      activitiesKicker: "WHAT WE DO",
      activitiesTitle: "Areas of work",
      activities: [
        { title: "Cultural promotion", desc: "Festivals, exhibitions, conferences, language courses and workshops dedicated to the cultures of the world." },
        { title: "Development cooperation", desc: "Projects for the education, health and living conditions of children and disadvantaged people." },
        { title: "Humanitarian aid", desc: "Emergency response and assistance to populations affected by crises, conflicts or disasters." },
        { title: "Rights and equality", desc: "Promotion of human rights, justice and gender equality." },
        { title: "Child sponsorship", desc: "Educational and psycho-affective support programmes for children." },
        { title: "Responsible tourism", desc: "Journeys of discovery, cultural exchange and mindful travel." },
      ],
      projectsKicker: "FEATURED PROJECTS",
      projectsTitle: "Concrete action, measurable impact",
      projectsAll: "All projects",
      ctaKicker: "SUPPORT US",
      ctaTitle: "Every contribution becomes education, culture and dignity.",
      ctaBody: "Donations directly support the organisation's projects. You can contribute securely through online payment.",
      ctaBtn: "Make a donation",
    },
    about: {
      heroKicker: "ABOUT US",
      heroTitleLines: ["An organisation", "for the common good"],
      heroIntro: "Common Ground Project is a private non-profit organisation pursuing civic purposes, international solidarity, cooperation among peoples and the valorisation of cultural diversity, in Italy and around the world.",
      missionKicker: "MISSION",
      missionTitle: "Culture and cooperation, without geographical borders",
      missionP1: "The organisation operates with no geographical limits, in Italy and in any country in the world. It promotes the knowledge of cultures, carries out development cooperation projects and provides humanitarian aid for children and people in disadvantaged conditions.",
      missionP2: "Every resource raised is dedicated to fulfilling the statutory aims.",
      valuesKicker: "OUR VALUES",
      valuesTitle: "Principles that guide our actions",
      values: ["Non-profit purpose", "Human and international solidarity", "Cooperation among peoples", "Appreciation of cultural diversity", "Promotion of human rights", "Equality and gender justice", "Fighting poverty and inequality", "Free and voluntary work"],
    },
    projects: {
      heroKicker: "PROJECTS",
      heroTitleLines: ["Where we work,", "what we build"],
      heroIntro: "Every project is documented with clear goals and verifiable results. Transparency and measurable impact are at the heart of the way we work.",
      where: {
        kicker: "WHERE WE WORK",
        title: "Italy and Senegal today, the world tomorrow",
        intro: "The organisation works with no geographical limits. Projects are currently active in Italy and Senegal; in the future our commitment will extend to new countries and communities around the world.",
        places: {
          italy: { name: "Italy", desc: "Cultural, awareness-raising and fundraising activities in support of the projects." },
          senegal: { name: "Senegal", desc: "Support for students and construction of the community centre." },
        },
      },
      galleryLabel: "PHOTO GALLERY",
      goalsLabel: "Goals",
      contribute: "Contribute to this project",
      items: [
        { id: "scuola-senegal", kicker: "Development cooperation", title: "Support for students in Senegal", location: "Senegal", status: "Ongoing", lead: "A primary-education support programme for the children of a rural community, aiming to ensure continuity of schooling, learning materials and a daily meal.", goals: ["Coverage of fees and school materials for full-year attendance.", "Supply of learning materials and support for educational activities.", "Support for children's nutrition through a daily meal.", "Regular monitoring of attendance and school results."], cover: IMG.senegal, gallery: [] },
        { id: "centro-aggregazione", kicker: "Culture and community", title: "Fundraising to develop a community centre", location: "Project in development", status: "In development", lead: "The new centre is conceived as a hub for gathering and culture: a reference point for the local community and a place of educational growth. It is designed as a flexible, evolving space, destined to become a beating heart for culture and encounter, where activities will be built together with its future visitors.", goals: ["Creation of a multi-purpose space for cultural, educational and social activities.", "A stable, open reference point for the local community.", "Participatory programming: activities defined together with those who will use the centre.", "Sustainability and gradual growth of the spaces over time."], cta: true, cover: IMG.centro, gallery: [] },
      ],
    },
    gallery: {
      heroKicker: "GALLERY",
      heroTitleLines: ["Images", "from the field"],
      closeLabel: "Close",
      altLabel: "Image",
    },
    transparency: {
      heroKicker: "TRANSPARENCY",
      heroTitleLines: ["Documents", "and reporting"],
      heroIntro: "Transparency is a core commitment. In this section we make the organisation's official documents available, along with information for anyone who wants to know and verify our work.",
      docsTitle: "Official documents",
      viewLabel: "View",
      downloadLabel: "Download",
      documents: [
        { file: "statuto", title: "Statute", desc: "The organisation's founding document: aims, activities, structure of the governing bodies and operating rules.", meta: "PDF" },
        { file: "adesione", title: "Membership form", desc: "Form to apply for membership of the organisation: fill it in, sign it and send it to the email address listed in the contacts.", meta: "PDF" },
      ],
      pillars: [
        { title: "Accessible documents", body: "The organisation's key documents are freely accessible and downloadable." },
        { title: "Non-profit nature", body: "The organisation pursues no profit purpose, not even indirectly." },
        { title: "Reporting", body: "Financial statements and activity reports will be published in this section." },
      ],
    },
    donatePage: {
      heroKicker: "SUPPORT US",
      heroTitleLines: ["Your contribution", "makes a difference"],
      heroIntro: "Concretely support the projects of Common Ground Project. Choose an amount or enter a custom one: you will be redirected to a secure payment page.",
      chooseTitle: "Choose your contribution",
      chooseSub: "One-time donation in Euro.",
      renewalTitle: "Membership fee renewal.",
      renewalBody: "Choose the fee amount and complete the payment: your card will be renewed by the organisation.",
      tiers: [
        { note: "Learning materials" },
        { note: "One month of support" },
        { note: "Meals and nutrition" },
        { note: "A significant contribution" },
      ],
      customLabel: "CUSTOM AMOUNT",
      customPlaceholder: "Other amount",
      submitIdle: "Proceed to donation",
      submitLoading: "Redirecting...",
      redirectNote: "You will be redirected to the secure Stripe payment page.",
      impact: [
        { title: "Direct allocation", body: "Donations are entirely dedicated to fulfilling the statutory aims." },
        { title: "Secure payment", body: "Transactions are handled securely through Stripe. We never store your card details." },
      ],
      quote: "\"Every contribution becomes education, culture and dignity.\"",
      errAmount: "Please enter a valid amount (minimum €2).",
      errGeneric: "Something went wrong. Please try again later.",
      errStart: "Unable to start the payment. Please try again.",
    },
    contact: {
      heroKicker: "CONTACT",
      heroTitleLines: ["Write to us,", "let's collaborate"],
      heroIntro: "For information about our projects, to become a member or to propose a collaboration, you can contact the organisation using the details below.",
      emailLabel: "Email",
      phoneLabel: "Phone",
    },
    login: {
      heroKicker: "MEMBERS AREA",
      heroTitleLines: ["Access your", "personal area"],
      quote: "\"Together we build a common ground.\"",
      heroIntro: "Reserved for Common Ground Project members. Enter your email: if you are an authorised member you can sign in with your password or create one on your first visit.",
      cardTitle: "Sign in to the members area",
      cardBody: "Access is limited to the email addresses of registered members. On your first visit you will be asked to choose a personal password.",
      protectedTitle: "Protected access",
      protectedBody: "Passwords are stored encrypted and your session stays active on this device. If you lose it, the organisation can reset your password.",
      unauthorized: "This address is not among the authorised members. If you are a member, write to",
      emailLabel: "Your member email",
      emailPlaceholder: "name@example.com",
      continueBtn: "Continue",
      passwordLabel: "Password",
      loginBtn: "Sign in",
      forgot: "Forgot your password?",
      back: "Change email",
      hello: "Hello",
      createIntro: "address confirmed: choose your password.",
      verifying: "Checking the link...",
      verifyIntro: "this is your first visit.",
      verifyBody: "For security we will send a confirmation link to",
      sendLinkBtn: "Send me the confirmation link",
      sentTitle: "Email sent!",
      sentBody: "We have sent a confirmation link to",
      sentHint: "Open it within one hour to create your password. Check your spam folder too.",
      newPasswordLabel: "New password",
      confirmPasswordLabel: "Confirm password",
      pwHint: "At least 8 characters",
      createBtn: "Create password and sign in",
      pwTooShort: "The password must be at least 8 characters long.",
      pwMismatch: "The two passwords do not match.",
      genericError: "Something went wrong. Please try again.",
    },
    member: {
      kicker: "MEMBERS-ONLY AREA",
      greeting: "Hello,",
      fallbackName: "member",
      cards: [
        { title: "Your profile", body: "Here you'll find your member details. Soon you'll be able to update your preferences and review your activity history." },
        { title: "Reserved documents", body: "Minutes, member communications and internal materials will be available in this reserved section." },
        { title: "Get involved", body: "Thank you for being part of Common Ground Project. Your contribution makes our cooperation projects possible." },
      ],
      logout: "Sign out",
      cardKicker: "MEMBERSHIP CARD 2026",
      cardNumber: "CARD NO.",
      cardJoined: "JOINED",
      cardExpires: "EXPIRES",
      cardFooter: "Digital card valid as proof of membership of Common Ground Project ETS.",
      renewExpiredTitle: "Your membership card has expired",
      renewExpiredBody: "Your membership card expired on {date}. Renew your fee to keep being part of Common Ground Project.",
      renewSoonTitle: "Your membership card is about to expire",
      renewSoonBody: "{days} days left until expiry ({date}). Renew your membership fee now to keep your member benefits.",
      renewBtn: "Renew membership",
      statusExpired: "Expired",
      statusExpiring: "Expires in {days} days",
      statusValid: "Valid",
      driveTitle: "Reserved documents",
      driveBody: "Minutes, member communications and internal materials are gathered in the shared folder.",
      driveButton: "Open the documents folder",
      driveRestricted: "Access to reserved documents (minutes, internal communications) is limited to members authorised by the board. If you believe you should have access, contact the organisation.",
      adminDocsBadge: "Documents",
      adminDocsGrant: "Documents: grant",
      adminDocsRevoke: "Documents: revoke",
      adminTitle: "Access management",
      adminSub: "Manage the members who can access the reserved area. You can add or remove addresses and reset a member's password.",
      adminPlaceholder: "email@example.com",
      adminAdd: "Authorise",
      adminRemove: "Remove",
      adminListLabel: "Authorised emails",
      adminNone: "No members registered.",
      adminNamePlaceholder: "Full name",
      adminCountLabel: "members",
      adminPwSet: "Password set",
      adminPwMissing: "Awaiting password",
      adminReset: "Reset password",
      adminResetDone: "Password reset: the member can create a new one at the next sign-in.",
      adminBadge: "Admin",
    },
    payment: {
      checking: "Verifying payment...",
      checkingBody: "Please wait a moment, we are confirming your donation.",
      paidTitle: "Thank you so much!",
      paidBody: (a) => `Your donation${a ? ` of €${a}` : ""} has been received successfully. Your support makes our projects possible.`,
      home: "Back to home",
      pendingTitle: "Payment processing",
      pendingBody: "You'll receive confirmation shortly. You can check again later.",
      errorTitle: "Something went wrong",
      errorBody: "We couldn't confirm the payment. Please try again or contact us.",
      retry: "Try again",
      cancelTitle: "Donation cancelled",
      cancelBody: "The payment was not completed. You can try again whenever you like: every contribution counts.",
    },
    cookie: {
      title: "Privacy and cookies",
      text: "This site uses technical cookies required to operate (language, Members area session) and, only during a donation, third-party cookies from the payment provider. We do not use profiling cookies.",
      accept: "Accept",
      necessary: "Necessary only",
      more: "Read the policy",
    },
    privacy: {
      heroKicker: "POLICY",
      heroTitleLines: ["Privacy", "and cookies"],
      heroIntro: "Information provided under Regulation (EU) 2016/679 (GDPR) on the processing of personal data of users of this website.",
      sections: [
        { title: "Data controller", body: "The data controller is Common Ground Project ETS. For any request concerning personal data you can write to {email}." },
        { title: "Data processed and purposes", body: "While browsing, technical data (IP address, browser type, pages visited) is collected as needed for the site to function and remain secure. If you sign in to the Members area, we process your name, email and password (stored only in encrypted form) to authenticate you. If you make a donation, payment data is processed directly by the payment provider (Stripe) and is not stored by the organisation." },
        { title: "Legal basis", body: "Processing is based on the performance of the service requested by the user (browsing, sign-in, donation), on the legitimate interest in site security and, where required, on consent." },
        { title: "Cookies used", body: "Technical cookies: language preference and cookie choice (stored in the browser), Members area sign-in session. Third-party cookies: only during payment, Stripe may set cookies required for fraud prevention. We do not use profiling or advertising cookies." },
        { title: "Retention", body: "Browsing data is kept only for as long as strictly necessary. The Members area session expires automatically after 7 days. Member profile data is kept while the user remains a member or until deletion is requested." },
        { title: "Your rights", body: "You have the right to access your data, request its rectification or erasure, restrict processing, object and request portability, and to lodge a complaint with the supervisory authority. You can exercise your rights by writing to {email}." },
        { title: "Managing consent", body: "You can change your cookie choice at any time using the button below." },
      ],
      resetBtn: "Change cookie preferences",
      updated: "Last updated: July 2026",
    },
    footer: {
      tagline: "A common ground for cooperation, culture and human dignity.",
      privacyLink: "Privacy and cookies",
      navTitle: "NAVIGATION",
      contactTitle: "CONTACT",
      ets: "Third Sector Entity",
    },
  },

  es: {
    nav: [
      { to: NAV_PATHS.home, label: "Inicio" },
      { to: NAV_PATHS.about, label: "Quiénes somos" },
      { to: NAV_PATHS.projects, label: "Proyectos" },
      { to: NAV_PATHS.gallery, label: "Imágenes del terreno" },
      { to: NAV_PATHS.contact, label: "Contacto" },
      { to: NAV_PATHS.members, label: "Área socios" },
    ],
    donate: "Colabora",
    home: {
      heroLead:
        "Common Ground Project es una organización privada sin ánimo de lucro que persigue finalidades cívicas, la solidaridad internacional, la cooperación entre los pueblos y la valorización de la diversidad cultural, en Italia y en todo el mundo.",
      heroMotto: "Acercamos lo que está lejos, hacemos visible lo invisible.",
      heroDonate: "Apoya los proyectos",
      heroProjects: "Nuestros proyectos",
      manifestoKicker: "NUESTRA MISIÓN",
      manifestoTitle: "Tres principios que guían cada acción",
      manifesto: [
        { n: "01", title: "Un terreno común", body: "Common Ground Project promueve el conocimiento y la valorización de las culturas, tradiciones y lenguas de los pueblos, favoreciendo el diálogo intercultural y la integración. Creemos que el diálogo es la primera herramienta de cooperación." },
        { n: "02", title: "Cooperación y dignidad", body: "Realizamos proyectos de cooperación al desarrollo en apoyo de la nutrición, el crecimiento, la educación y el desarrollo de menores y personas en situación de desventaja, en Italia y en el mundo." },
        { n: "03", title: "Derechos e igualdad", body: "Trabajamos por la promoción de los derechos humanos fundamentales, la justicia y la igualdad de género, y contra toda forma de discriminación, pobreza y desigualdad económica y social." },
      ],
      activitiesKicker: "QUÉ HACEMOS",
      activitiesTitle: "Ámbitos de actuación",
      activities: [
        { title: "Promoción cultural", desc: "Festivales, exposiciones, conferencias, cursos de idiomas y talleres dedicados a las culturas del mundo." },
        { title: "Cooperación al desarrollo", desc: "Proyectos para la educación, la salud y las condiciones de vida de menores y personas desfavorecidas." },
        { title: "Ayuda humanitaria", desc: "Intervenciones de emergencia y asistencia a poblaciones afectadas por crisis, conflictos o catástrofes." },
        { title: "Derechos e igualdad", desc: "Promoción de los derechos humanos, la justicia y la igualdad de género." },
        { title: "Apadrinamiento a distancia", desc: "Programas de apoyo educativo y psicoafectivo para menores." },
        { title: "Turismo responsable", desc: "Viajes de conocimiento, intercambio cultural y turismo consciente." },
      ],
      projectsKicker: "PROYECTOS DESTACADOS",
      projectsTitle: "Acciones concretas, impacto medible",
      projectsAll: "Todos los proyectos",
      ctaKicker: "COLABORA",
      ctaTitle: "Cada contribución se convierte en educación, cultura y dignidad.",
      ctaBody: "Las donaciones apoyan directamente los proyectos de la organización. Puedes contribuir de forma segura mediante pago en línea.",
      ctaBtn: "Haz una donación",
    },
    about: {
      heroKicker: "QUIÉNES SOMOS",
      heroTitleLines: ["Una organización", "para el bien común"],
      heroIntro: "Common Ground Project es una organización privada sin ánimo de lucro que persigue finalidades cívicas, la solidaridad internacional, la cooperación entre los pueblos y la valorización de la diversidad cultural, en Italia y en todo el mundo.",
      missionKicker: "MISIÓN",
      missionTitle: "Cultura y cooperación, sin fronteras geográficas",
      missionP1: "La organización opera sin límites geográficos, en Italia y en cualquier país del mundo. Promueve el conocimiento de las culturas, realiza proyectos de cooperación al desarrollo y presta ayuda humanitaria a favor de menores y personas en situación de desventaja.",
      missionP2: "Cada recurso recaudado se destina a la realización de los fines estatutarios.",
      valuesKicker: "NUESTROS VALORES",
      valuesTitle: "Principios que orientan nuestro actuar",
      values: ["Ausencia de ánimo de lucro", "Solidaridad humana e internacional", "Cooperación entre los pueblos", "Valorización de la diversidad cultural", "Promoción de los derechos humanos", "Igualdad y justicia de género", "Lucha contra la pobreza y la desigualdad", "Voluntariado libre y gratuito"],
    },
    projects: {
      heroKicker: "PROYECTOS",
      heroTitleLines: ["Dónde actuamos,", "qué realizamos"],
      heroIntro: "Cada proyecto está documentado con objetivos claros y resultados verificables. La transparencia y el impacto medible son el centro de nuestra forma de trabajar.",
      where: {
        kicker: "DÓNDE OPERAMOS",
        title: "Hoy Italia y Senegal, mañana el mundo",
        intro: "La organización opera sin límites geográficos. Hoy los proyectos están activos en Italia y Senegal; en el futuro el compromiso se extenderá a nuevos países y comunidades de todo el mundo.",
        places: {
          italy: { name: "Italia", desc: "Actividades culturales, de sensibilización y de recaudación de fondos en apoyo de los proyectos." },
          senegal: { name: "Senegal", desc: "Apoyo a los estudiantes y construcción del centro comunitario." },
        },
      },
      galleryLabel: "GALERÍA FOTOGRÁFICA",
      goalsLabel: "Objetivos",
      contribute: "Contribuye al proyecto",
      items: [
        { id: "scuola-senegal", kicker: "Cooperación al desarrollo", title: "Apoyo a los estudiantes de Senegal", location: "Senegal", status: "En curso", lead: "Un programa de apoyo a la educación primaria dirigido a los niños de una comunidad rural, con el objetivo de garantizar la continuidad escolar, material didáctico y una comida diaria.", goals: ["Cobertura de las cuotas y del material escolar para la asistencia durante todo el año.", "Suministro de material didáctico y apoyo a las actividades educativas.", "Apoyo a la nutrición de los menores mediante una comida diaria.", "Seguimiento periódico de la asistencia y de los resultados escolares."], cover: IMG.senegal, gallery: [] },
        { id: "centro-aggregazione", kicker: "Cultura y comunidad", title: "Recaudación de fondos para el desarrollo de un centro comunitario", location: "Proyecto en desarrollo", status: "En desarrollo", lead: "El nuevo centro nace como polo de encuentro y cultura: un punto de referencia para la comunidad local y un lugar de crecimiento educativo. Está concebido como un espacio flexible y en evolución, destinado a convertirse en un corazón palpitante para la cultura y el encuentro, donde las actividades se construirán junto a sus futuros participantes.", goals: ["Creación de un espacio polivalente para actividades culturales, educativas y sociales.", "Un punto de referencia estable y abierto para la comunidad local.", "Programación participativa: actividades definidas junto a quienes usarán el centro.", "Sostenibilidad y crecimiento progresivo de los espacios con el tiempo."], cta: true, cover: IMG.centro, gallery: [] },
      ],
    },
    gallery: {
      heroKicker: "GALERÍA",
      heroTitleLines: ["Imágenes", "del terreno"],
      closeLabel: "Cerrar",
      altLabel: "Imagen",
    },
    transparency: {
      heroKicker: "TRANSPARENCIA",
      heroTitleLines: ["Documentos", "y rendición de cuentas"],
      heroIntro: "La transparencia es un compromiso fundamental. En esta sección ponemos a disposición los documentos oficiales de la organización y la información útil para quien quiera conocer y verificar nuestra labor.",
      docsTitle: "Documentos oficiales",
      viewLabel: "Consultar",
      downloadLabel: "Descargar",
      documents: [
        { file: "statuto", title: "Estatutos", desc: "Documento constitutivo de la organización: fines, actividades, estructura de los órganos sociales y reglas de funcionamiento.", meta: "PDF" },
        { file: "adesione", title: "Formulario de adhesión", desc: "Formulario para solicitar la adhesión a la organización como socio: rellénalo, fírmalo y envíalo a la dirección de correo indicada en los contactos.", meta: "PDF" },
      ],
      pillars: [
        { title: "Documentos consultables", body: "Los documentos fundamentales de la organización son de libre acceso y descarga." },
        { title: "Naturaleza sin ánimo de lucro", body: "La organización no persigue ningún fin lucrativo, ni siquiera indirecto." },
        { title: "Rendición de cuentas", body: "El balance y los informes de actividad se publicarán en esta sección." },
      ],
    },
    donatePage: {
      heroKicker: "COLABORA",
      heroTitleLines: ["Tu contribución", "marca la diferencia"],
      heroIntro: "Apoya de forma concreta los proyectos de Common Ground Project. Elige un importe o introduce una cantidad personalizada: serás dirigido a una página de pago segura.",
      chooseTitle: "Elige tu contribución",
      chooseSub: "Donación única en euros.",
      renewalTitle: "Renovación de la cuota de socio.",
      renewalBody: "Elige el importe de la cuota y completa el pago: la organización renovará tu carnet.",
      tiers: [
        { note: "Material didáctico" },
        { note: "Un mes de apoyo" },
        { note: "Comidas y nutrición" },
        { note: "Una contribución importante" },
      ],
      customLabel: "IMPORTE PERSONALIZADO",
      customPlaceholder: "Otro importe",
      submitIdle: "Proceder a la donación",
      submitLoading: "Redirigiendo...",
      redirectNote: "Serás redirigido a la página de pago segura de Stripe.",
      impact: [
        { title: "Destino directo", body: "Las donaciones se destinan íntegramente a la realización de los fines estatutarios." },
        { title: "Pago seguro", body: "Las transacciones se gestionan de forma segura mediante Stripe. No conservamos los datos de tu tarjeta." },
      ],
      quote: "\"Cada contribución se convierte en educación, cultura y dignidad.\"",
      errAmount: "Introduce un importe válido (mínimo 2€).",
      errGeneric: "Se ha producido un error. Inténtalo de nuevo más tarde.",
      errStart: "No se pudo iniciar el pago. Inténtalo de nuevo.",
    },
    contact: {
      heroKicker: "CONTACTO",
      heroTitleLines: ["Escríbenos,", "colaboremos"],
      heroIntro: "Para información sobre los proyectos, para hacerte socio o para proponer una colaboración, puedes contactar con la organización a través de los datos indicados.",
      emailLabel: "Correo",
      phoneLabel: "Teléfono",
    },
    login: {
      heroKicker: "ÁREA SOCIOS",
      heroTitleLines: ["Accede a tu", "área personal"],
      quote: "\"Juntos construimos un terreno común.\"",
      heroIntro: "Reservada a los socios de Common Ground Project. Introduce tu email: si eres socio autorizado podrás acceder con tu contraseña o crear una en tu primer acceso.",
      cardTitle: "Accede al área de socios",
      cardBody: "El acceso está reservado a las direcciones de email de los socios registrados. En el primer acceso te pediremos elegir una contraseña personal.",
      protectedTitle: "Acceso protegido",
      protectedBody: "Las contraseñas se guardan cifradas y la sesión permanece activa en este dispositivo. Si la pierdes, la organización puede restablecer tu contraseña.",
      unauthorized: "Esta dirección no figura entre los socios autorizados. Si eres socio, escribe a",
      emailLabel: "Tu email de socio",
      emailPlaceholder: "nombre@ejemplo.es",
      continueBtn: "Continuar",
      passwordLabel: "Contraseña",
      loginBtn: "Acceder",
      forgot: "¿Olvidaste la contraseña?",
      back: "Cambiar email",
      hello: "Hola",
      createIntro: "dirección confirmada: elige tu contraseña.",
      verifying: "Comprobando el enlace...",
      verifyIntro: "es tu primer acceso.",
      verifyBody: "Por seguridad te enviaremos un enlace de confirmación a",
      sendLinkBtn: "Enviarme el enlace de confirmación",
      sentTitle: "¡Email enviado!",
      sentBody: "Hemos enviado un enlace de confirmación a",
      sentHint: "Ábrelo en el plazo de una hora para crear tu contraseña. Revisa también la carpeta de spam.",
      newPasswordLabel: "Nueva contraseña",
      confirmPasswordLabel: "Confirmar contraseña",
      pwHint: "Al menos 8 caracteres",
      createBtn: "Crear contraseña y acceder",
      pwTooShort: "La contraseña debe tener al menos 8 caracteres.",
      pwMismatch: "Las dos contraseñas no coinciden.",
      genericError: "Algo salió mal. Inténtalo de nuevo.",
    },
    member: {
      kicker: "ÁREA RESERVADA A SOCIOS",
      greeting: "Hola,",
      fallbackName: "socio/a",
      cards: [
        { title: "Tu perfil", body: "Aquí encontrarás tus datos de socio/a. Pronto podrás actualizar tus preferencias y consultar el historial de actividades." },
        { title: "Documentos reservados", body: "Actas, comunicaciones a los socios y materiales internos estarán disponibles en esta sección reservada." },
        { title: "Participa", body: "Gracias por formar parte de Common Ground Project. Tu contribución hace posibles nuestros proyectos de cooperación." },
      ],
      logout: "Salir",
      cardKicker: "CARNET DE SOCIO 2026",
      cardNumber: "N.º DE CARNET",
      cardJoined: "ALTA",
      cardExpires: "VENCIMIENTO",
      cardFooter: "Carnet digital válido como certificado de adhesión a Common Ground Project ETS.",
      renewExpiredTitle: "Tu carnet de socio ha caducado",
      renewExpiredBody: "El carnet de socio caducó el {date}. Renueva la cuota para seguir formando parte de Common Ground Project.",
      renewSoonTitle: "Tu carnet de socio está a punto de caducar",
      renewSoonBody: "Faltan {days} días para el vencimiento ({date}). Renueva ahora la cuota para no perder las ventajas de socio.",
      renewBtn: "Renovar la cuota",
      statusExpired: "Caducado",
      statusExpiring: "Caduca en {days} días",
      statusValid: "Válido",
      driveTitle: "Documentos reservados",
      driveBody: "Actas, comunicaciones a los socios y materiales internos están en la carpeta compartida.",
      driveButton: "Abrir la carpeta de documentos",
      driveRestricted: "El acceso a los documentos reservados (actas, comunicaciones internas) está limitado a los socios autorizados por la junta directiva. Si crees que deberías tener acceso, contacta con la organización.",
      adminDocsBadge: "Documentos",
      adminDocsGrant: "Documentos: permitir",
      adminDocsRevoke: "Documentos: revocar",
      adminTitle: "Gestión de accesos",
      adminSub: "Gestiona los socios que pueden acceder al área reservada. Puedes añadir o eliminar direcciones y restablecer la contraseña de un socio.",
      adminPlaceholder: "correo@ejemplo.com",
      adminAdd: "Autorizar",
      adminRemove: "Eliminar",
      adminListLabel: "Correos autorizados",
      adminNone: "Ningún socio registrado.",
      adminNamePlaceholder: "Nombre y apellidos",
      adminCountLabel: "socios",
      adminPwSet: "Contraseña creada",
      adminPwMissing: "Pendiente de contraseña",
      adminReset: "Restablecer contraseña",
      adminResetDone: "Contraseña restablecida: el socio podrá crear una nueva en su próximo acceso.",
      adminBadge: "Admin",
    },
    payment: {
      checking: "Verificando el pago...",
      checkingBody: "Espera un momento, estamos confirmando tu donación.",
      paidTitle: "¡Muchas gracias!",
      paidBody: (a) => `Tu donación${a ? ` de ${a}€` : ""} se ha recibido con éxito. Tu apoyo hace posibles nuestros proyectos.`,
      home: "Volver al inicio",
      pendingTitle: "Pago en proceso",
      pendingBody: "Recibirás la confirmación en breve. Puedes comprobarlo más tarde.",
      errorTitle: "Algo salió mal",
      errorBody: "No hemos podido confirmar el pago. Inténtalo de nuevo o contáctanos.",
      retry: "Reintentar",
      cancelTitle: "Donación cancelada",
      cancelBody: "El pago no se ha completado. Puedes volver a intentarlo cuando quieras: cada contribución cuenta.",
    },
    cookie: {
      title: "Privacidad y cookies",
      text: "Este sitio utiliza cookies técnicas necesarias para su funcionamiento (idioma, sesión del Área socios) y, solo durante una donación, cookies de terceros del proveedor de pagos. No utilizamos cookies de perfilado.",
      accept: "Aceptar",
      necessary: "Solo necesarias",
      more: "Leer la política",
    },
    privacy: {
      heroKicker: "POLÍTICA",
      heroTitleLines: ["Privacidad", "y cookies"],
      heroIntro: "Información facilitada conforme al Reglamento (UE) 2016/679 (RGPD) sobre el tratamiento de los datos personales de los usuarios de este sitio.",
      sections: [
        { title: "Responsable del tratamiento", body: "El responsable del tratamiento es Common Ground Project ETS. Para cualquier solicitud relativa a los datos personales puede escribir a {email}." },
        { title: "Datos tratados y finalidades", body: "Durante la navegación se recogen datos técnicos (dirección IP, tipo de navegador, páginas visitadas) necesarios para el funcionamiento y la seguridad del sitio. Si accede al Área socios, tratamos su nombre, email y contraseña (guardada únicamente de forma cifrada) para autenticarle. Si realiza una donación, los datos de pago son tratados directamente por el proveedor de pagos (Stripe) y no son almacenados por la organización." },
        { title: "Base jurídica", body: "El tratamiento se basa en la prestación del servicio solicitado por el usuario (navegación, acceso, donación), en el interés legítimo en la seguridad del sitio y, cuando se requiere, en el consentimiento." },
        { title: "Cookies utilizadas", body: "Cookies técnicas: preferencia de idioma y elección de cookies (guardadas en el navegador), sesión de acceso del Área socios. Cookies de terceros: solo durante el pago, Stripe puede instalar cookies necesarias para la prevención del fraude. No utilizamos cookies de perfilado ni publicitarias." },
        { title: "Conservación", body: "Los datos de navegación se conservan solo el tiempo estrictamente necesario. La sesión del Área socios caduca automáticamente a los 7 días. Los datos del perfil de socio se conservan mientras el usuario siga siendo socio o hasta que solicite su eliminación." },
        { title: "Derechos del interesado", body: "Tiene derecho a acceder a sus datos, solicitar su rectificación o supresión, limitar el tratamiento, oponerse y solicitar la portabilidad, así como presentar una reclamación ante la autoridad de control. Puede ejercer sus derechos escribiendo a {email}." },
        { title: "Gestión del consentimiento", body: "Puede modificar en cualquier momento su elección sobre las cookies con el botón de abajo." },
      ],
      resetBtn: "Cambiar preferencias de cookies",
      updated: "Última actualización: julio de 2026",
    },
    footer: {
      tagline: "Un terreno común para la cooperación, la cultura y la dignidad de las personas.",
      privacyLink: "Privacidad y cookies",
      navTitle: "NAVEGACIÓN",
      contactTitle: "CONTACTO",
      ets: "Entidad del Tercer Sector",
    },
  },

  fr: {
    nav: [
      { to: NAV_PATHS.home, label: "Accueil" },
      { to: NAV_PATHS.about, label: "À propos" },
      { to: NAV_PATHS.projects, label: "Projets" },
      { to: NAV_PATHS.gallery, label: "Images du terrain" },
      { to: NAV_PATHS.contact, label: "Contact" },
      { to: NAV_PATHS.members, label: "Espace membres" },
    ],
    donate: "Nous soutenir",
    home: {
      heroLead:
        "Common Ground Project est une organisation privée à but non lucratif qui poursuit des finalités civiques, la solidarité internationale, la coopération entre les peuples et la valorisation de la diversité culturelle, en Italie et dans le monde.",
      heroMotto: "Nous rapprochons ce qui est lointain, nous rendons visible l'invisible.",
      heroDonate: "Soutenir les projets",
      heroProjects: "Nos projets",
      manifestoKicker: "NOTRE MISSION",
      manifestoTitle: "Trois principes qui guident chaque action",
      manifesto: [
        { n: "01", title: "Un terrain commun", body: "Common Ground Project promeut la connaissance et la valorisation des cultures, des traditions et des langues des peuples, en favorisant le dialogue interculturel et l'intégration. Nous croyons que le dialogue est le premier outil de coopération." },
        { n: "02", title: "Coopération et dignité", body: "Nous menons des projets de coopération au développement en faveur de la nutrition, de la croissance, de l'éducation et du développement des enfants et des personnes en situation de vulnérabilité, en Italie et dans le monde." },
        { n: "03", title: "Droits et égalité", body: "Nous œuvrons pour la promotion des droits humains fondamentaux, de la justice et de l'égalité des genres, et contre toute forme de discrimination, de pauvreté et d'inégalité économique et sociale." },
      ],
      activitiesKicker: "CE QUE NOUS FAISONS",
      activitiesTitle: "Domaines d'action",
      activities: [
        { title: "Promotion culturelle", desc: "Festivals, expositions, conférences, cours de langues et ateliers dédiés aux cultures du monde." },
        { title: "Coopération au développement", desc: "Projets pour l'éducation, la santé et les conditions de vie des enfants et des personnes défavorisées." },
        { title: "Aide humanitaire", desc: "Interventions d'urgence et assistance aux populations touchées par des crises, des conflits ou des catastrophes." },
        { title: "Droits et égalité", desc: "Promotion des droits humains, de la justice et de l'égalité des genres." },
        { title: "Parrainage à distance", desc: "Programmes de soutien éducatif et psycho-affectif pour les enfants." },
        { title: "Tourisme responsable", desc: "Voyages de découverte, échanges culturels et tourisme conscient." },
      ],
      projectsKicker: "PROJETS À LA UNE",
      projectsTitle: "Des actions concrètes, un impact mesurable",
      projectsAll: "Tous les projets",
      ctaKicker: "NOUS SOUTENIR",
      ctaTitle: "Chaque contribution devient éducation, culture et dignité.",
      ctaBody: "Les dons soutiennent directement les projets de l'organisation. Vous pouvez contribuer en toute sécurité par paiement en ligne.",
      ctaBtn: "Faire un don",
    },
    about: {
      heroKicker: "À PROPOS",
      heroTitleLines: ["Une organisation", "pour le bien commun"],
      heroIntro: "Common Ground Project est une organisation privée à but non lucratif qui poursuit des finalités civiques, la solidarité internationale, la coopération entre les peuples et la valorisation de la diversité culturelle, en Italie et dans le monde.",
      missionKicker: "MISSION",
      missionTitle: "Culture et coopération, sans frontières géographiques",
      missionP1: "L'organisation agit sans limite géographique, en Italie et dans tout pays du monde. Elle promeut la connaissance des cultures, mène des projets de coopération au développement et fournit une aide humanitaire en faveur des enfants et des personnes en situation de vulnérabilité.",
      missionP2: "Chaque ressource collectée est consacrée à la réalisation des objectifs statutaires.",
      valuesKicker: "NOS VALEURS",
      valuesTitle: "Des principes qui orientent notre action",
      values: ["Absence de but lucratif", "Solidarité humaine et internationale", "Coopération entre les peuples", "Valorisation de la diversité culturelle", "Promotion des droits humains", "Égalité et justice de genre", "Lutte contre la pauvreté et les inégalités", "Bénévolat libre et gratuit"],
    },
    projects: {
      heroKicker: "PROJETS",
      heroTitleLines: ["Où nous agissons,", "ce que nous réalisons"],
      heroIntro: "Chaque projet est documenté avec des objectifs clairs et des résultats vérifiables. La transparence et l'impact mesurable sont au cœur de notre façon de travailler.",
      where: {
        kicker: "OÙ NOUS AGISSONS",
        title: "Aujourd'hui l'Italie et le Sénégal, demain le monde",
        intro: "L'organisation agit sans limite géographique. Les projets sont aujourd'hui actifs en Italie et au Sénégal ; à l'avenir, notre engagement s'étendra à de nouveaux pays et communautés dans le monde entier.",
        places: {
          italy: { name: "Italie", desc: "Activités culturelles, de sensibilisation et de collecte de fonds en soutien aux projets." },
          senegal: { name: "Sénégal", desc: "Soutien aux élèves et construction du centre communautaire." },
        },
      },
      galleryLabel: "GALERIE PHOTO",
      goalsLabel: "Objectifs",
      contribute: "Contribuer au projet",
      items: [
        { id: "scuola-senegal", kicker: "Coopération au développement", title: "Soutien aux élèves du Sénégal", location: "Sénégal", status: "En cours", lead: "Un programme de soutien à l'éducation primaire destiné aux enfants d'une communauté rurale, visant à garantir la continuité scolaire, du matériel pédagogique et un repas quotidien.", goals: ["Prise en charge des frais et du matériel scolaire pour une année entière de scolarité.", "Fourniture de matériel pédagogique et soutien aux activités éducatives.", "Soutien à la nutrition des enfants par un repas quotidien.", "Suivi régulier de l'assiduité et des résultats scolaires."], cover: IMG.senegal, gallery: [] },
        { id: "centro-aggregazione", kicker: "Culture et communauté", title: "Collecte de fonds pour le développement d'un centre communautaire", location: "Projet en développement", status: "En développement", lead: "Le nouveau centre est conçu comme un pôle de rencontre et de culture : un point de référence pour la communauté locale et un lieu de croissance éducative. Il est pensé comme un espace flexible et évolutif, destiné à devenir un cœur battant pour la culture et la rencontre, où les activités seront construites avec ses futurs usagers.", goals: ["Création d'un espace polyvalent pour des activités culturelles, éducatives et sociales.", "Un point de référence stable et ouvert pour la communauté locale.", "Programmation participative : activités définies avec celles et ceux qui fréquenteront le centre.", "Durabilité et croissance progressive des espaces dans le temps."], cta: true, cover: IMG.centro, gallery: [] },
      ],
    },
    gallery: {
      heroKicker: "GALERIE",
      heroTitleLines: ["Images", "du terrain"],
      closeLabel: "Fermer",
      altLabel: "Image",
    },
    transparency: {
      heroKicker: "TRANSPARENCE",
      heroTitleLines: ["Documents", "et reddition de comptes"],
      heroIntro: "La transparence est un engagement fondamental. Dans cette section, nous mettons à disposition les documents officiels de l'organisation ainsi que les informations utiles à qui veut connaître et vérifier notre action.",
      docsTitle: "Documents officiels",
      viewLabel: "Consulter",
      downloadLabel: "Télécharger",
      documents: [
        { file: "statuto", title: "Statuts", desc: "Document fondateur de l'organisation : objectifs, activités, structure des organes sociaux et règles de fonctionnement.", meta: "PDF" },
        { file: "adesione", title: "Formulaire d'adhésion", desc: "Formulaire pour demander l'adhésion à l'organisation en tant que membre : remplissez-le, signez-le et envoyez-le à l'adresse email indiquée dans les contacts.", meta: "PDF" },
      ],
      pillars: [
        { title: "Documents consultables", body: "Les documents fondamentaux de l'organisation sont librement accessibles et téléchargeables." },
        { title: "But non lucratif", body: "L'organisation ne poursuit aucun but lucratif, même indirect." },
        { title: "Reddition de comptes", body: "Le bilan et les rapports d'activité seront publiés dans cette section." },
      ],
    },
    donatePage: {
      heroKicker: "NOUS SOUTENIR",
      heroTitleLines: ["Votre contribution", "fait la différence"],
      heroIntro: "Soutenez concrètement les projets de Common Ground Project. Choisissez un montant ou saisissez une somme personnalisée : vous serez redirigé vers une page de paiement sécurisée.",
      chooseTitle: "Choisissez votre contribution",
      chooseSub: "Don unique en euros.",
      renewalTitle: "Renouvellement de la cotisation.",
      renewalBody: "Choisissez le montant de la cotisation et finalisez le paiement : votre carte sera renouvelée par l'organisation.",
      tiers: [
        { note: "Matériel pédagogique" },
        { note: "Un mois de soutien" },
        { note: "Repas et nutrition" },
        { note: "Une contribution importante" },
      ],
      customLabel: "MONTANT PERSONNALISÉ",
      customPlaceholder: "Autre montant",
      submitIdle: "Procéder au don",
      submitLoading: "Redirection...",
      redirectNote: "Vous serez redirigé vers la page de paiement sécurisée Stripe.",
      impact: [
        { title: "Affectation directe", body: "Les dons sont intégralement consacrés à la réalisation des objectifs statutaires." },
        { title: "Paiement sécurisé", body: "Les transactions sont gérées en toute sécurité via Stripe. Nous ne conservons pas les données de votre carte." },
      ],
      quote: "\"Chaque contribution devient éducation, culture et dignité.\"",
      errAmount: "Saisissez un montant valide (minimum 2€).",
      errGeneric: "Une erreur s'est produite. Veuillez réessayer plus tard.",
      errStart: "Impossible de démarrer le paiement. Veuillez réessayer.",
    },
    contact: {
      heroKicker: "CONTACT",
      heroTitleLines: ["Écrivez-nous,", "collaborons"],
      heroIntro: "Pour toute information sur les projets, pour devenir membre ou pour proposer une collaboration, vous pouvez contacter l'organisation aux coordonnées indiquées.",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone",
    },
    login: {
      heroKicker: "ESPACE MEMBRES",
      heroTitleLines: ["Accédez à votre", "espace personnel"],
      quote: "\"Ensemble, nous construisons un terrain commun.\"",
      heroIntro: "Réservé aux membres de Common Ground Project. Saisissez votre email : si vous êtes membre autorisé, vous pourrez vous connecter avec votre mot de passe ou en créer un lors de votre première visite.",
      cardTitle: "Accéder à l'espace membres",
      cardBody: "L'accès est réservé aux adresses email des membres enregistrés. Lors de votre première connexion, nous vous demanderons de choisir un mot de passe personnel.",
      protectedTitle: "Accès protégé",
      protectedBody: "Les mots de passe sont enregistrés de façon chiffrée et votre session reste active sur cet appareil. En cas d'oubli, l'organisation peut réinitialiser votre mot de passe.",
      unauthorized: "Cette adresse ne figure pas parmi les membres autorisés. Si vous êtes membre, écrivez à",
      emailLabel: "Votre email de membre",
      emailPlaceholder: "nom@exemple.fr",
      continueBtn: "Continuer",
      passwordLabel: "Mot de passe",
      loginBtn: "Se connecter",
      forgot: "Mot de passe oublié ?",
      back: "Changer d'email",
      hello: "Bonjour",
      createIntro: "adresse confirmée : choisissez votre mot de passe.",
      verifying: "Vérification du lien...",
      verifyIntro: "c'est votre première connexion.",
      verifyBody: "Par sécurité, nous vous enverrons un lien de confirmation à",
      sendLinkBtn: "M'envoyer le lien de confirmation",
      sentTitle: "Email envoyé !",
      sentBody: "Nous avons envoyé un lien de confirmation à",
      sentHint: "Ouvrez-le dans l'heure pour créer votre mot de passe. Vérifiez aussi vos spams.",
      newPasswordLabel: "Nouveau mot de passe",
      confirmPasswordLabel: "Confirmer le mot de passe",
      pwHint: "Au moins 8 caractères",
      createBtn: "Créer le mot de passe et se connecter",
      pwTooShort: "Le mot de passe doit contenir au moins 8 caractères.",
      pwMismatch: "Les deux mots de passe ne correspondent pas.",
      genericError: "Une erreur s'est produite. Veuillez réessayer.",
    },
    member: {
      kicker: "ESPACE RÉSERVÉ AUX MEMBRES",
      greeting: "Bonjour,",
      fallbackName: "membre",
      cards: [
        { title: "Votre profil", body: "Vous trouverez ici vos informations de membre. Bientôt, vous pourrez mettre à jour vos préférences et consulter l'historique des activités." },
        { title: "Documents réservés", body: "Comptes rendus, communications aux membres et documents internes seront disponibles dans cette section réservée." },
        { title: "Participez", body: "Merci de faire partie de Common Ground Project. Votre contribution rend possibles nos projets de coopération." },
      ],
      logout: "Se déconnecter",
      cardKicker: "CARTE DE MEMBRE 2026",
      cardNumber: "N° DE CARTE",
      cardJoined: "ADHÉSION",
      cardExpires: "EXPIRATION",
      cardFooter: "Carte numérique valant attestation d'adhésion à Common Ground Project ETS.",
      renewExpiredTitle: "Votre carte de membre a expiré",
      renewExpiredBody: "Votre carte de membre a expiré le {date}. Renouvelez votre cotisation pour continuer à faire partie de Common Ground Project.",
      renewSoonTitle: "Votre carte de membre arrive à expiration",
      renewSoonBody: "Il reste {days} jours avant l'expiration ({date}). Renouvelez dès maintenant votre cotisation pour conserver vos avantages de membre.",
      renewBtn: "Renouveler la cotisation",
      statusExpired: "Expirée",
      statusExpiring: "Expire dans {days} jours",
      statusValid: "Valide",
      driveTitle: "Documents réservés",
      driveBody: "Comptes rendus, communications aux membres et documents internes sont réunis dans le dossier partagé.",
      driveButton: "Ouvrir le dossier des documents",
      driveRestricted: "L'accès aux documents réservés (procès-verbaux, communications internes) est limité aux membres autorisés par le conseil. Si vous pensez devoir y avoir accès, contactez l'organisation.",
      adminDocsBadge: "Documents",
      adminDocsGrant: "Documents : autoriser",
      adminDocsRevoke: "Documents : révoquer",
      adminTitle: "Gestion des accès",
      adminSub: "Gérez les membres qui peuvent accéder à l'espace réservé. Vous pouvez ajouter ou supprimer des adresses et réinitialiser le mot de passe d'un membre.",
      adminPlaceholder: "email@exemple.com",
      adminAdd: "Autoriser",
      adminRemove: "Supprimer",
      adminListLabel: "E-mails autorisés",
      adminNone: "Aucun membre enregistré.",
      adminNamePlaceholder: "Nom et prénom",
      adminCountLabel: "membres",
      adminPwSet: "Mot de passe défini",
      adminPwMissing: "En attente de mot de passe",
      adminReset: "Réinitialiser le mot de passe",
      adminResetDone: "Mot de passe réinitialisé : le membre pourra en créer un nouveau à sa prochaine connexion.",
      adminBadge: "Admin",
    },
    payment: {
      checking: "Vérification du paiement...",
      checkingBody: "Patientez un instant, nous confirmons votre don.",
      paidTitle: "Merci infiniment !",
      paidBody: (a) => `Votre don${a ? ` de ${a}€` : ""} a bien été reçu. Votre soutien rend nos projets possibles.`,
      home: "Retour à l'accueil",
      pendingTitle: "Paiement en cours de traitement",
      pendingBody: "Vous recevrez une confirmation sous peu. Vous pouvez vérifier plus tard.",
      errorTitle: "Une erreur s'est produite",
      errorBody: "Nous n'avons pas pu confirmer le paiement. Réessayez ou contactez-nous.",
      retry: "Réessayer",
      cancelTitle: "Don annulé",
      cancelBody: "Le paiement n'a pas été finalisé. Vous pouvez réessayer quand vous voulez : chaque contribution compte.",
    },
    cookie: {
      title: "Confidentialité et cookies",
      text: "Ce site utilise des cookies techniques nécessaires à son fonctionnement (langue, session de l'Espace membres) et, uniquement lors d'un don, des cookies tiers du prestataire de paiement. Nous n'utilisons pas de cookies de profilage.",
      accept: "Accepter",
      necessary: "Nécessaires uniquement",
      more: "Lire la politique",
    },
    privacy: {
      heroKicker: "POLITIQUE",
      heroTitleLines: ["Confidentialité", "et cookies"],
      heroIntro: "Informations fournies conformément au Règlement (UE) 2016/679 (RGPD) sur le traitement des données personnelles des utilisateurs de ce site.",
      sections: [
        { title: "Responsable du traitement", body: "Le responsable du traitement est Common Ground Project ETS. Pour toute demande relative aux données personnelles, vous pouvez écrire à {email}." },
        { title: "Données traitées et finalités", body: "Lors de la navigation, des données techniques (adresse IP, type de navigateur, pages visitées) sont collectées pour le fonctionnement et la sécurité du site. Si vous vous connectez à l'Espace membres, nous traitons votre nom, votre email et votre mot de passe (enregistré uniquement sous forme chiffrée) pour vous authentifier. Si vous faites un don, les données de paiement sont traitées directement par le prestataire de paiement (Stripe) et ne sont pas conservées par l'organisation." },
        { title: "Base juridique", body: "Le traitement repose sur l'exécution du service demandé par l'utilisateur (navigation, connexion, don), sur l'intérêt légitime à la sécurité du site et, lorsque c'est requis, sur le consentement." },
        { title: "Cookies utilisés", body: "Cookies techniques : préférence de langue et choix des cookies (enregistrés dans le navigateur), session de connexion de l'Espace membres. Cookies tiers : uniquement lors du paiement, Stripe peut déposer des cookies nécessaires à la prévention de la fraude. Nous n'utilisons pas de cookies de profilage ou publicitaires." },
        { title: "Conservation", body: "Les données de navigation sont conservées uniquement le temps strictement nécessaire. La session de l'Espace membres expire automatiquement après 7 jours. Les données du profil membre sont conservées tant que l'utilisateur reste membre ou jusqu'à demande de suppression." },
        { title: "Droits de la personne concernée", body: "Vous avez le droit d'accéder à vos données, d'en demander la rectification ou l'effacement, d'en limiter le traitement, de vous y opposer et d'en demander la portabilité, ainsi que d'introduire une réclamation auprès de l'autorité de contrôle. Vous pouvez exercer vos droits en écrivant à {email}." },
        { title: "Gestion du consentement", body: "Vous pouvez modifier à tout moment votre choix concernant les cookies à l'aide du bouton ci-dessous." },
      ],
      resetBtn: "Modifier les préférences cookies",
      updated: "Dernière mise à jour : juillet 2026",
    },
    footer: {
      tagline: "Un terrain commun pour la coopération, la culture et la dignité des personnes.",
      privacyLink: "Confidentialité et cookies",
      navTitle: "NAVIGATION",
      contactTitle: "CONTACT",
      ets: "Entité du Tiers Secteur",
    },
  },
};

export const DONATION_TIERS = [
  { id: "tier_10", amount: 10 },
  { id: "tier_25", amount: 25 },
  { id: "tier_50", amount: 50 },
  { id: "tier_100", amount: 100 },
];
